__turbopack_context__.v({
  "culture": "Ytp5aq_culture",
});
